import React,{Component} from 'react';
import { ref } from '../config/constants'
import {formatPrice} from '../helpers/helpers'

class QMainProduct extends Component{
    constructor(){
        super();
        this.handleChange = this.handleChange.bind(this)
        this.handleTotal = this.handleTotal.bind(this)
        this.handleDiscount = this.handleDiscount.bind(this)
        this.delete = this.delete.bind(this)
        this.state = {
            product :{},
            total : 0,
            discount : 0,
            pretotal : 0,
            thickness : "",
            quantity : 0
                     
            
        }
    }

    componentWillMount(){
        let prodData = ref.child("Products").child(this.props.product)
            prodData.on("value",function(data){
                
                    this.setState({
                        product : data.val()
                    })
                    //this.props.setProduct(data.val(),this.props.index)
                    
            }.bind(this))
           
                                              
    }

    
    
    handleChange(e){
        let product = this.state.product
        //let quantity = this.state.quantity
        var labor = 0
            if(this.productThickness.value ==="price_4MM"){
                labor = product.laborPrice_4MM
                this.setState({
                    thickness : "price_4MM"
                })
            }
            if(this.productThickness.value ==="price_5MM"){
                labor = product.laborPrice_5MM
                this.setState({
                    thickness : "price_5MM"
                })
            }
            if(this.productThickness.value ==="price_6MM"){
                labor = product.laborPrice_6MM
                this.setState({
                    thickness : "price_6MM"
                })
            }
            if(this.productThickness.value ==="price_8MM"){
                labor = product.laborPrice_8MM
                this.setState({
                    thickness : "price_8MM"
                })
            }
        let update = {
                ...product,
                laborPrice : labor,
                price : this.state.product[e.target.value],
                //number : this.state.quantity
            }
        
        this.setState({
            product : update
        })

        if(this.productNumber.value){
            //console.log("n")
            let total = this.productNumber.value * this.state.product[e.target.value]
                total= total.toFixed(2)

                this.setState({
                    total : total,
                    pretotal : total
                })
        }

    }

    handleTotal(e){
       // let quan = (e.target.value) ? e.target.value : 1
        let total = this.state.product.price *  e.target.value
            total= total.toFixed(2)
            this.setState({
                total,
                pretotal : total
            })
        let product = this.state.product
        let update = {
                ...product,
                number :parseInt( e.target.value,10)
            }

        this.setState({
            product : update,
            //quantity :  e.target.value
        })

    }

    handleDiscount(e){
        
        let total = this.state.pretotal
        let discount = e.target.value/100
        let dis = total - (total * discount)
        
            this.setState({
                total : dis
            }) 
            this.setState({
                discount : e.target.value
            })
           
    }
    
    delete(index){
        this.props.remove(index)
        this.props.removeTotal(index)
    }

    componentDidUpdate(prevProps,prevState){
        
        if(prevState.product !== this.state.product){
           
           this.props.setProductsLabor(this.state.product,this.props.index)
           this.props.setItem(this.state.product.name)
           let thickness = this.productThickness.value
                thickness = thickness.slice(-3)
           this.props.setThickness(thickness)
           

        }

        if(prevState.total !== this.state.total){
            
            this.props.getTotal(this.props.index,this.state.total)
        }
        
        if(prevState.pretotal !== this.state.pretotal){
           
            if(this.state.discount > 0){
                
                let total = this.state.pretotal
                let discount = this.productDiscount.value/100
                let dis = total - (total * discount)
            
                this.setState({
                    total : dis
                })
            }
        }
    }

    render() {       
            
        return (
            
                    <tr>
                        <td>
                            <div className="row nomarginLR">
                                <div className="col-lg-7 col-md-5  col-sm-8 col-xs-8 nopaddingLR">
                                    <p className="text-uppercase">{this.state.product.name}</p>
                                </div>
                                <div className="col-lg-5 col-md-3 col-sm-3 col-xs-3 nopaddingLR">
                                    <button type="button" className="btn btn-sm btn-danger" onClick={()=>this.delete(this.props.index)}><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                </div>
                            </div>
                            
                            <input type="hidden" className="form-control" name="productName" ref={input => this.productName = input} value={this.state.product.name}/>
                        </td>
                        <td>
                            <p className="text-uppercase">{this.state.product.dimension}</p>
                            <input type="hidden" className="form-control" name="category" ref={input => this.category = input} value="Main Product"/>
                            <input type="hidden" className="form-control" name="productId" ref={input => this.productId = input} value={this.props.product}/>
                            <input type="hidden" className="form-control" name="productDimension" ref={input => this.productDimension = input} value={this.state.product.dimension}/>
                        </td>
                        <td>
                            <select className="form-control" name="productThickness" ref={input => this.productThickness = input}  onChange={this.handleChange}>
                                <option>Select Thickness</option>
                                <option value="price_4MM">0.4MM</option>
                                <option value="price_5MM">0.5MM</option>
                                <option value="price_6MM">0.6MM</option>
                                <option value="price_8MM">0.8MM</option>
                            </select>
                        </td>
                        <td>
                            
                                <input type="text" className="form-control" name="productNumber" ref={input => this.productNumber = input}   onChange={this.handleTotal} />
                            
                        </td>
                        <td>
                            <p>{`${this.state.product.unit}`}
                                <input type="hidden" className="form-control" name="productUnit" ref={input => this.productUnit = input} value={this.state.product.unit} />
                            </p>
                        </td>
                        <td>
                            <p>{this.state.product.price}
                                <input type="hidden" className="form-control" name="productPrice" ref={input => this.productPrice = input} value={this.state.product.price} />
                            </p>
                        </td>
                         <td>
                            <p>{`/${this.state.product.unit}`}
                                <input type="hidden" className="form-control" name="productUnit" ref={input => this.productUnit = input} value={this.state.product.unit} />
                            </p>
                        </td>
                        <td>
                           <input type="text" className="form-control"  name="productDiscount" ref={input => this.productDiscount = input} value={this.state.discount} onChange={this.handleDiscount} />
                        </td>
                        <td>
                            <p>{formatPrice(this.state.total)}</p>
                            <input type="hidden" className="form-control" name ="productTotal" ref={input => this.productTotal = input} value={this.state.total} />
                        </td>
                    </tr>
                 

        );
    }
}

export default  QMainProduct;


// WEBPACK FOOTER //
// ./src/components/QMainProduct.js